export default function Navigation({ navShow, navOpen, navTextures, solar, cur, onGoTo, onToggleNav, logoSrc }) {
  return (
    <>
      <div id="nav-backdrop" className={navOpen ? "show" : ""} onClick={() => onToggleNav(false)} />

      <div id="left-nav" className={`${navShow ? "show" : ""} ${navOpen ? "nav-open" : ""}`}>
        <div id="nav-logo">
          <img src={logoSrc} alt="HOGC" className="hogc-logo" width="130" height="130" style={{ width: 130, height: 130, objectFit: "contain" }} />
        </div>
        <div id="nav-list">
          {solar.map((p, idx) => (
            <div key={p.id}>
              {idx > 0 && <div className="nav-sep" />}
              <button className={`nav-planet${cur === idx ? " active" : ""}`} onClick={() => onGoTo(idx)}>
                <div className="nav-ring">
                  <div className="nav-dot" />
                </div>
                <div className="nav-sphere-wrap">
                  {navTextures[p.id] ? (
                    <div
                      className="nav-sphere-tex"
                      style={{
                        backgroundImage: `url("${navTextures[p.id].url}")`,
                        backgroundSize: `${Math.round(38 * navTextures[p.id].aspect)}px 38px`,
                        width: `${Math.round(38 * navTextures[p.id].aspect)}px`,
                        backgroundRepeat: "repeat-x",
                        animation: `spin ${p.speed} linear infinite`,
                        "--tex-w": `${Math.round(38 * navTextures[p.id].aspect)}px`,
                      }}
                    />
                  ) : (
                    <div className="nav-sphere-tex" />
                  )}
                </div>
                <div className="nav-info">
                  <div className="nav-label">{p.name}</div>
                  <div className="nav-dist">{p.au}</div>
                </div>
              </button>
            </div>
          ))}
        </div>
      </div>

      <div id="topbar" className={navShow ? "show" : ""}>
        <button id="burger" className={navOpen ? "open" : ""} onClick={() => onToggleNav()}>
          <span />
          <span />
          <span />
        </button>
        <div id="mobile-logo">
          <img src={logoSrc} alt="HOGC" className="hogc-mobile-logo" />
        </div>
        {/* <div id="counter">{String(cur + 1).padStart(2, "0")} / {String(solar.length).padStart(2, "0")}</div> */}
      </div>

      <div id="nav-dots" className={navShow ? "show" : ""}>
        {solar.map((p, i) => (
          <div key={p.id} className={`ndot${cur === i ? " on" : ""}`} onClick={() => onGoTo(i)} />
        ))}
      </div>
    </>
  );
}
